import React from 'react';
import { Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';

const Label = ({ labelName }) => {
  return (
    <div className="main-content-form-headers" style={{ marginBottom: '9px' }}>
      <Typography>{labelName}</Typography>
    </div>
  );
};

Label.propTypes = {
  labelName: PropTypes.string.isRequired
};

export default Label;
